/**
 * ZAR currency, formatted the way a South African writes it and the same
 * way in every browser: a space groups thousands and a comma is the
 * decimal — R 1 234 567,89. Intl's en-ZA is not consistent across
 * engines (older Android WebViews render R1,234,567.89), so this is done
 * by hand. The thousands separator is a narrow no-break space so an
 * amount never wraps mid-number.
 */
const THIN = ' '; // narrow no-break space
function groupDigits(intPart) {
    return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, THIN);
}
/** R 1 234 567,89 — with cents. Negative amounts use a real minus sign. */
export function formatZarCents(cents) {
    const negative = cents < 0;
    const abs = Math.round(Math.abs(cents));
    const rand = Math.floor(abs / 100).toString();
    const frac = (abs % 100).toString().padStart(2, '0');
    return `${negative ? '−' : ''}R${THIN}${groupDigits(rand)},${frac}`;
}
/**
 * R 1 234 568 — rounded to whole Rand, no cents. For totals and KPI
 * figures, where cents are noise. Rounds to the nearest Rand.
 */
export function formatZarWhole(cents) {
    const negative = cents < 0;
    const rand = Math.round(Math.abs(cents) / 100).toString();
    return `${negative ? '−' : ''}R${THIN}${groupDigits(rand)}`;
}
const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
/**
 * A yyyy-mm-dd ISO date as a South African reads it: 31 Aug 2026.
 * Deterministic, no timezone maths (the input is already a calendar
 * date). Returns the input unchanged if it is not an ISO date, so it is
 * safe to wrap any value. ISO strings stay in CSV and machine output.
 */
export function formatSaDate(iso) {
    if (!iso)
        return '';
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m)
        return iso;
    const month = MONTHS_SHORT[Number(m[2]) - 1] ?? m[2];
    return `${Number(m[3])} ${month} ${m[1]}`;
}
/** "31 Aug 2026, 14:05" from a yyyy-mm-dd hh:mm stamp. */
export function formatSaDateTime(stamp) {
    if (!stamp)
        return '';
    const [date, time] = stamp.split(' ');
    return time ? `${formatSaDate(date)}, ${time}` : formatSaDate(date);
}
export function countWords(text) {
    const trimmed = text.trim();
    if (!trimmed)
        return 0;
    return trimmed.split(/\s+/).length;
}
/** Fractional ordering key for Kanban drag-drop (midpoint insertion). */
export function midpointSortOrder(before, after) {
    if (before === null && after === null)
        return 1000;
    if (before === null)
        return after - 1000;
    if (after === null)
        return before + 1000;
    return (before + after) / 2;
}
